module.exports = __webpack_public_path__ + "img/noimageavailable.c9d2864c.png";